import { render, staticRenderFns } from "./AppPaginationPlus.vue?vue&type=template&id=89c77d3e&scoped=true"
import script from "./AppPaginationPlus.vue?vue&type=script&lang=js"
export * from "./AppPaginationPlus.vue?vue&type=script&lang=js"
import style0 from "./AppPaginationPlus.vue?vue&type=style&index=0&id=89c77d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c77d3e",
  null
  
)

export default component.exports